// Eine lange Arbeit, die jemand in der Kanzlei angestoßen hat und die ohne Eingaben weiterläuft (z. B. die KI liest
// ein langes PDF in Teilen), zählt für die automatische Abmeldung (kanzlei/IdleLogout.tsx) wie eine Eingabe.
export const ACTIVE_EVENT = 'elbcons:aktiv';

export function stillActive() {
  window.dispatchEvent(new Event(ACTIVE_EVENT));
}
